import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { Toaster } from "sonner";

import "@/App.css";
import { AuthProvider } from "@/context/AuthContext";
import { I18nProvider } from "@/context/I18nContext";
import HomePage from "@/pages/HomePage";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";
import ProtectedRoute from "@/components/ProtectedRoute";

function App() {
    return (
        <HelmetProvider>
            <I18nProvider>
                <AuthProvider>
                    <BrowserRouter>
                        <Routes>
                            <Route path="/" element={<HomePage />} />
                            <Route path="/admin/login" element={<AdminLogin />} />
                            <Route
                                path="/admin"
                                element={
                                    <ProtectedRoute>
                                        <AdminDashboard />
                                    </ProtectedRoute>
                                }
                            />
                        </Routes>
                        <Toaster
                            position="bottom-right"
                            theme="dark"
                            toastOptions={{
                                style: {
                                    background: "#121212",
                                    color: "#F5F5F0",
                                    border: "1px solid rgba(212, 175, 55, 0.25)",
                                },
                            }}
                        />
                    </BrowserRouter>
                </AuthProvider>
            </I18nProvider>
        </HelmetProvider>
    );
}

export default App;
